<template>
  <div v-loading="loading">
    <!-- If Stripe Alternative Needed -->
    <div v-if="stage === 'no-stripe'">
      <div class="container max-w-screen-md">
        <wavy-card>
          <div class="-mb-36">
            <div class="absolute left-0 right-0 top-0 flex justify-center">
              <div class="-mt-12 text-6xl">
                <img src="@/assets/brand/icon.svg" class="w-auto inline-block h-16 p-2.5 bg-brand-black rounded-full" alt="Logo" />
              </div>
            </div>
            <div class="mt-8 text-center">
              <p class="font-bold text-center text-brand-black text-2xl">Not using Stripe? No problem.</p>
              <p class="font-semibold text-brand-brown text-center text-lg mt-1">
                Our experienced integrations team can have you up and running quickly. Let's schedule a quick meeting to review your specific needs.
              </p>
              <div class="mt-8">
                <el-button @click="scheduleCall" type="primary" class="text-lg font-semibold py-4">Schedule Now →</el-button>
                <div class="mt-8">
                  <div class="text-center text-brand-brown font-semibold">If you are using Stripe, click below.</div>
                  <div class="text-center mt-3">
                    <el-button plain @click="resetProvider()">Connect Stripe</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </wavy-card>
      </div>
    </div>
    <!-- CK LITE ALTERNATIVE -->
    <!-- <div v-if="stage === 'no-stripe'">
      <div class="border-brand-sand border-2 py-8 px-12 max-w-screen-sm mx-auto shadow-sm rounded-lg">
        <p class="font-bold text-center text-brand-black text-2xl">Not using Stripe? No problem.</p>
        <p class="font-semibold text-brand-brown text-center text-lg mt-2">
          <span class="text-green-600 font-extrabold">Churnkey Lite</span> offers the best of Churnkey without needing to connect your payment provider. Get
          access to a no-code offbording builder and an interactive dashboard to find out exactly why your customers are thinking about cancelling.
        </p>
        <div class="mt-4">
          <a href="/lite" class="el-button w-full text-lg font-semibold py-4 el-button--primary">
            Get Churnkey Lite →
          </a>
        </div>
      </div>
      <div class="mt-8">
        <div class="text-center text-gray-600 font-semibold">Using a different subscription billing system? We can help!</div>
        <div class="text-center mt-3">
          <el-button plain @click="scheduleCall">Talk to our Integration Team</el-button>
        </div>
      </div>
    </div> -->
    <!-- If Connecting Stripe -->
    <div v-if="stage === 'connect'">
      <div class="border-brand-sand border-2 py-8 px-12 max-w-screen-sm mx-auto shadow-sm rounded-lg">
        <p class="font-bold text-center text-brand-black text-2xl">Connect Your Stripe Account</p>
        <p class="font-semibold text-brand-brown text-center text-lg mt-1">
          With one click, Stripe will send Churnkey your transaction data, subscription plans, coupons, customer data, and will enable subscription
          pauses.
        </p>
        <div>
          <div class="mt-8 text-center">
            <font-awesome-icon :icon="['fab', 'stripe']" class="text-6xl" :style="{ color: '#32325d' }" />
          </div>
        </div>
        <div class="mt-4">
          <a :href="stripeConnectUrlLive" class="el-button w-full text-lg font-semibold py-4 el-button--primary"> Connect Your Stripe Account → </a>
        </div>
        <div class="mt-4">
          <button @click="goToCalendar" class="el-button el-button--default is-plain w-full text-lg font-semibold py-4">Not Right Now</button>
        </div>
      </div>
      <div class="mt-8">
        <div class="text-center text-gray-600 font-semibold">Using a different subscription billing system? We can help!</div>
        <div class="text-center mt-3">
          <el-button plain @click="scheduleCall">Talk to our Integration Team</el-button>
        </div>
      </div>
    </div>
    <!-- STRIPE PROCESSING STATE -->
    <div v-else-if="stage === 'processing'">
      <div class="container max-w-screen-md">
        <wavy-card>
          <div class="-mb-36">
            <div class="absolute left-0 right-0 top-0 flex justify-center">
              <div class="-mt-12 text-6xl">
                <img src="@/assets/brand/icon.svg" class="w-auto inline-block h-16 p-2.5 bg-brand-black rounded-full" alt="Logo" />
              </div>
            </div>
            <div class="mt-8 text-center">
              <p class="font-bold text-center text-brand-black text-2xl">
                Churnkey is building something great for you. You'll get an email when we're ready.
              </p>
              <p class="font-semibold text-brand-brown text-center text-lg mt-1">
                Importing your Stripe transactions, subscriptions, and coupons can take several hours. In the meantime, let's get you started on
                installing Churnkey's code snippet.
              </p>
              <div class="mt-12">
                <el-button @click="goToBuilder" type="primary" class="text-lg font-semibold py-4">Install Code Snippet →</el-button>
              </div>
            </div>
          </div>
        </wavy-card>
      </div>
    </div>
    <!-- STRIPE ERROR STATE -->
    <div v-else-if="stage === 'error'">
      <div class="container max-w-screen-md">
        <wavy-card>
          <div class="-mb-36">
            <div class="absolute left-0 right-0 top-0 flex justify-center">
              <font-awesome-layers class="-mt-8 text-6xl">
                <font-awesome-icon :icon="['fas', 'circle']" class="text-brand-red" />
                <font-awesome-icon :icon="['fab', 'stripe']" class="text-black opacity-50 text-3xl" />
              </font-awesome-layers>
            </div>
            <div class="mt-8 text-center">
              <p class="font-bold text-center text-brand-black text-2xl">Sorry. Stripe returned an error.</p>
              <p class="font-semibold text-brand-brown text-center text-lg mt-1">
                Churnkey couldn't access your data, or there was no data to access. Please try connecting your Stripe account one more time.
              </p>
              <div class="mt-12">
                <el-button type="primary" class="text-lg font-semibold py-4">Try to Connect Stripe Again →</el-button>
              </div>
            </div>
          </div>
        </wavy-card>
        <div class="mt-64">
          <div class="text-center text-gray-600 font-semibold">Feel free to reach out via chat. We're here to help.</div>
          <!-- <div class="text-center mt-3">
            <el-button type="primary" plain>Chat Now</el-button>
          </div> -->
        </div>
      </div>
    </div>
    <!-- STRIPE READY STATE -->
    <div v-else-if="stage === 'ready'">
      <div class="container max-w-screen-md">
        <wavy-card>
          <div class="-mb-36">
            <div class="absolute left-0 right-0 top-0 flex justify-center">
              <div class="-mt-12 text-6xl">
                <img src="@/assets/brand/icon.svg" class="w-auto inline-block h-16 p-2.5 bg-brand-black rounded-full" alt="Logo" />
              </div>
            </div>
            <div class="mt-8 text-center">
              <p class="font-bold text-center text-brand-black text-2xl">Churnkey is ready for you!</p>
              <p class="font-semibold text-brand-brown text-center text-lg mt-1">Great! Let's get started.</p>
              <div class="mt-12">
                <el-button @click="goToBuilder" type="primary" class="text-lg font-semibold py-4">Let's Go Already →</el-button>
              </div>
            </div>
          </div>
        </wavy-card>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from '@/api/auth.service';
import WavyCard from '@/components/UI/WavyCard.vue';
import * as actions from '@/store/action-types';

const stripeClientIdLive = 'ca_I4LOcF9sJYgxdwmpNGPMn0buaBAdyh6Q';
const stripeClientIdTest = 'ca_I4LOYSW5co4HuYMTsK2TW9xH0x2ZQ5vP';

export default {
  name: 'OnboardConnectStripe',
  components: {
    WavyCard,
  },
  data() {
    return {
      stage: 'connect', // connect, processing, error, ready
      loading: true,
    };
  },
  async created() {
    if (this.$route.query.code) {
      const authCode = this.$route.query.code;
      await this.stripeAuthCallback(authCode);
    }
    await this.$store.dispatch(actions.SYNC_ORG);

    if (this.$store.state.org.paymentProvider && this.$store.state.org.paymentProvider !== 'stripe') {
      this.stage = 'no-stripe';
    }
    this.loading = false;
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    stripeRedirectUri() {
      // stripe requires https
      const origin = window.location.origin.replace('http:', 'https:');
      return window.encodeURIComponent(`${origin}${this.$route.path}`);
    },
    stripeConnectBaseUrl() {
      return `https://connect.stripe.com/oauth/authorize?response_type=code&scope=read_write&redirect_uri=${this.stripeRedirectUri}`;
    },
    stripeConnectUrlLive() {
      return `${this.stripeConnectBaseUrl}&client_id=${stripeClientIdLive}`;
    },
    stripeConnectUrlTest() {
      return `${this.stripeConnectBaseUrl}&client_id=${stripeClientIdTest}`;
    },
  },
  methods: {
    async stripeAuthCallback(authCode) {
      this.stage = 'processing';
      try {
        await AuthService.stripeAuthCallback(authCode, this.user._id);
        this.stage = 'ready';
      } catch (error) {
        this.stage = 'error';
        console.log('error', error);
      }
    },
    goToBuilder() {
      this.$router.push('/cancellation/flows');
    },
    scheduleCall() {
      // eslint-disable-next-line no-undef
      SavvyCal('open', { link: 'churnkey-team/support', metadata: { page: window.location.pathname }, theme: 'os' });
    },
    goToCalendar() {
      // go to dedicated savvycal calendar page
      this.$router.push('/onboard/setup');
    },
    resetProvider() {
      this.stage = 'connect';
    },
  },
};
</script>
